import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isBenignResizeObserverError } from './utils/observeElementSize';
import { installAxiosTransientRetry } from './utils/installAxiosTransientRetry';
import { installAxiosAuthRefresh } from './utils/installAxiosAuthRefresh';
import {
  installAxiosOutageGuard,
  installToastOutageGuard,
} from './utils/installAxiosOutageGuard';
import { installOnScreenNotify } from './utils/installOnScreenNotify';

// Silent JWT refresh after idle + survive brief API 502/503 during deploys.
installAxiosAuthRefresh();
installAxiosTransientRetry();
// After retries exhaust: calm banner + suppress red toast spam for outages.
installAxiosOutageGuard();
installToastOutageGuard();
// Prefer in-layout status banners over corner toast pops (string messages).
installOnScreenNotify();

// CRA / webpack-dev-server overlay treats this browser quirk as a fatal runtime error.
// Suppress it as early as possible (before React mounts).
if (typeof window !== 'undefined') {
  const suppressResizeObserverNoise = (event) => {
    const message = event?.message || event?.reason?.message || event?.reason || '';
    if (isBenignResizeObserverError(message)) {
      event.stopImmediatePropagation?.();
      event.preventDefault?.();
      return true;
    }
    return false;
  };
  window.addEventListener('error', suppressResizeObserverNoise, true);
  window.addEventListener('unhandledrejection', suppressResizeObserverNoise, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
